module.exports = __webpack_public_path__ + "static/img/17.a7fdcb6f.jpeg";